<div style="transform: translateY(6px);height: 28px;" class="positions-totals-container">
    <div
    [ngClass]="isReviewPage ? 'totals-text-alignment-review ag-cell ag-cell-not-inline-editing ag-cell-normal-height ag-right-aligned-cell ag-cell-value' :
     'totals-text-alignment ag-cell ag-cell-not-inline-editing ag-cell-normal-height ag-right-aligned-cell ag-cell-value'">
    <b>Totals</b>
    </div>
    <div [ngClass]="isReviewPage ? 'ag-cell ag-right-aligned-cell total-shares-text-alignment-review' : 'ag-cell ag-right-aligned-cell total-shares-text-alignment'"><b>{{sharesSelected}}</b></div>
    <div
    [ngClass]="isReviewPage ? 'ag-cell ag-cell-not-inline-editing ag-cell-normal-height ag-right-aligned-cell ag-cell-value total-value-text-alignment-review' : 'ag-cell ag-cell-not-inline-editing ag-cell-normal-height ag-right-aligned-cell ag-cell-value total-value-text-alignment'">
        <b>{{totalValue}}</b>
    </div>
</div>